<template>
  <v-card class="collectionDetail">
    <v-card-title>
      <h2>{{ pageTitle }}</h2>
      <br/>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Organization Name: {{name}}</v-list-item-subtitle>
          <v-list-item-subtitle>Zoho Reference No: {{refno}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-data-table
            v-if="isCollection == true"
            :headers="collection_headers"
            :items="items"
            hide-default-footer
          >
          <template v-slot:item.startDate="props">
              <span>{{ props.item.startDate | dateUtcToLocal }}</span>
            </template>
            <template v-slot:item.endDate="props">
              <span>{{ props.item.endDate | dateUtcToLocal }}</span>
            </template>
          </v-data-table>

          <v-data-table
            v-else
            :headers="purchaseOrder_headers"
            :items="items"
            hide-default-footer
          >
          <template v-slot:item.StartDate="props">
              <span>{{ props.item.StartDate | dateUtcToLocal }}</span>
            </template>
            <template v-slot:item.EndDate="props">
              <span>{{ props.item.EndDate | dateUtcToLocal }}</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <div class="row">
        <div class="col d-flex justify-end">
          <div class="col d-flex justify-start">
            <v-btn class="" @click="onBackToFulfillment" id="btnBack">Back</v-btn>
          </div>
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import moment from "moment";
import lodash from "lodash";
import * as api from "@/api";
export default {
  components: {
    Notification,
    Pagination
  },
  data() {
    return {
      collection_headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "Name"
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "Description"
        },
        {
          text: "Price",
          align: "start",
          sortable: false,
          value: "Price"
        },
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "startDate"
        },
        {
          text: "End Date",
          align: "start",
          sortable: false,
          value: "endDate"
        },
        {
          text: "Core Collection",
          align: "start",
          sortable: false,
          value: "isCoreCollection"
        }
      ],
      purchaseOrder_headers: [
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: "Author Name",
          align: "start",
          sortable: false,
          value: "AuthorName"
        },
        {
          text: "Publisher Name",
          align: "start",
          sortable: false,
          value: "PublisherName"
        },
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "StartDate"
        },
        {
          text: "End Date",
          align: "start",
          sortable: false,
          value: "EndDate"
        },
      ],
      items: [],
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      list: [],
      name: null,
      refno:null,
      parentPage: null,
      isCollection: false,
      pageTitle: ""
    };
  },
  methods: {
    onNextPage() {},
    getItemDetails(id, isCollection) {
      let that = this;
      let url =
        Boolean(isCollection) == true
          ? "purchase-order/collection/" + id
          : "purchase-order/publication/" + id;
      that.items.splice(0, that.items.length);
      new Promise((resolve, reject) => {
        api
          .getByPagin(url, this.paging)
          .then(response => {
            if (
              response.data != null &&
              response.data.data != null &&
              response.data.data.length > 0
            ) {
              response.data.data.forEach(e => {
                that.items.push(e);
              });
            } else {
              console.warn("No Collection Details found");
              console.warn(response.data.data);
            }
          })
          .catch(error => {
            reject(error);
            that.overlay = false;
          });
      });
    },
    onBackToFulfillment() {
      if (this.isCollection) {
        this.$router.push({
          name: "FulfillmentCollections",
          params: { page: this.parentPage }
        });
      }else {
        this.$router.push({
          name: "Purchase",
          params: { page: this.parentPage }
        });
      }
    }
  },
  mounted() {
    console.log("id param value...");
    console.log(this.$route.params);
    this.parentPage = this.$route.params.page;
    this.isCollection = Boolean(this.$route.params.collection);
    this.name = this.$route.params.name;
    this.refno = this.$route.params.refno;
    if (this.isCollection) {
      this.pageTitle = "Collections Fulfillment Details";
    } else {
      this.pageTitle = "Ebook Purchase Details";
    }
    this.getItemDetails(this.$route.params.id, this.$route.params.collection);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/FulfillmentCollectionDetail.vue